// --------------------- Import Globais ---------------------
import { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
// --------------------- Import Antd-Design ---------------------
import { Form, Input, Modal, Select, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";

// --------------------- Import Hooks ---------------------
import { useCadastrarIndicacoesParceiros } from "../hooks/useCadastrarIndicacoesParceiros";
import { useBuscarParceiros } from "../../ViewGerenciarParceiros/hooks/useParceiros";
// --------------------- Import Styles ---------------------
import { Title } from "../../ViewGerenciarPostagens/styles";
// --------------------- Import Uteis ---------------------
import { useMessage } from "../../../uteis/mensagens/useMessage";
import { formStyle, layout } from "../styles";
import { IndicacaoParceiro } from "../../../interfaces/IndicacaoParceiro";

export default function ModalAdicionar({
  isModalOpen,
  handleFechar,
  buscar,
}: any) {
  const [formCadastrarIndicacao] = Form.useForm();

  const { parceiros, isLoading: isLoadingParceiros } = useBuscarParceiros();

  // Chamada da função para cadastrar
  const {
    cadastrar,
    isLoading: isLoadingCadastrar,
    error,
    success,
    resetSuccess,
    resetError,
  } = useCadastrarIndicacoesParceiros();

  // Estado inicial de dos dados Postagem que serão atualizados
  const [indicacaoData, setIndicacaoData] = useState<
    Partial<IndicacaoParceiro>
  >({});

  // Função que armazena os dados alterados de Apartamento
  const indicacaoChange = (
    changedValues: Partial<IndicacaoParceiro>,
    allValues: IndicacaoParceiro
  ) => {
    setIndicacaoData(allValues);
  };

  const [phone, setPhone] = useState("");

  const handlePhoneChange = (value: string) => {
    setPhone(value);
  };

  // Exibe a Mensagem
  const { showSuccess, showError, contextHolder } = useMessage();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();
  useEffect(() => {
    if (isModalOpen && success && !successDisplayed) {
      // Mensagem de sucesso
      const msgSuccess = "Indicação cadastrada com sucesso!";
      showSuccess(msgSuccess);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        resetSuccess();
        handleFechar();
        buscar();
      }, 2000);
    }

    if (isModalOpen && error && !errorDisplayed) {
      // Mensagem de erro
      let msgError =
        "Não foi possível cadastrar esta indicação, por favor tente novamente!";
      showError(msgError);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }

    // Reset quando o modal fecha
    if (!isModalOpen) {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    resetSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    navigate,
    resetError,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        width={700}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Adicionar"
        onOk={() => cadastrar(indicacaoData)}
        confirmLoading={isLoadingCadastrar}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          },
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          },
        }}
      >
        {isLoadingParceiros ? (
          <Skeleton active />
        ) : (
          <>
            {contextHolder}

            <Form
              {...layout}
              form={formCadastrarIndicacao}
              onValuesChange={(changedValues, allValues) =>
                indicacaoChange(changedValues, allValues)
              }
              name="indicacao-form"
            >
              <Title>Adicionar Indicação</Title>

              <Form.Item name="nome" label="Lead" className="formItems">
                <Input />
              </Form.Item>

              <Form.Item
                name="idParceiro"
                label="Parceiro"
                className="formItems"
              >
                <Select placeholder="Selecione um parceiro">
                  {parceiros.map((parceiro) => (
                    <Select.Option key={parceiro.id} value={parceiro.id}>
                      {parceiro.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="celular"
                label="Celular"
                className="formItems"
                getValueFromEvent={(value) => value}
              >
                <PhoneInput
                  country="br"
                  value={phone}
                  onChange={handlePhoneChange}
                  placeholder="Digite seu telefone"
                  inputClass="phone-input"
                />
              </Form.Item>
            </Form>
          </>
        )}
      </Modal>
    </>
  );
}
